import React, { useState, useEffect, useContext, useRef } from "react";
import { useTranslation } from "react-i18next";
import css from "./index.module.scss";
import MobileContext from "../../context.js";
import { Swiper, SwiperSlide } from "swiper/react";
import { useInView, animated } from "@react-spring/web";

import "swiper/css";
import "swiper/css/effect-coverflow";

import { EffectCoverflow } from "swiper/modules";

const qualifications = [
  {
    name: "环境管理体系证书",
    pic: require("../../../../assets/qualifications/1.jpg"),
  },
  {
    name: "统信-海光认证证书",
    pic: require("../../../../assets/qualifications/2.jpg"),
  },
  {
    name: "统信-兆芯POS-MIS认证证书",
    pic: require("../../../../assets/qualifications/3.jpg"),
  },
  {
    name: "银联卡受理商户信息系统企业资质认证证书-2023",
    pic: require("../../../../assets/qualifications/4.jpg"),
  },
  {
    name: "CMMI3",
    pic: require("../../../../assets/qualifications/5.jpg"),
  },
  {
    name: "ISO信息安全管理体系认证证书27001-2013",
    pic: require("../../../../assets/qualifications/6.jpg"),
  },
  {
    name: "ISO信息技术服务管理体系认证20000-2018",
    pic: require("../../../../assets/qualifications/7.jpg"),
  },
  {
    name: "ISO质量管理体系认证证书9001-2016",
    pic: require("../../../../assets/qualifications/8.jpg"),
  },
];

const honors = [
  {
    name: "2023年度杭州总部企业",
    pic: require("../../../../assets/honors/2023zbqy.png"),
  },
  {
    name: "2022年度高质量发展突出贡献奖",
    pic: require("../../../../assets/honors/1.jpg"),
  },
  {
    name: "2022年度科技人才创新示范企业",
    pic: require("../../../../assets/honors/2.jpg"),
  },
  {
    name: "高新技术企业证书",
    pic: require("../../../../assets/honors/3.jpg"),
  },
  {
    name: "省级高新技术企业研究开发中心",
    pic: require("../../../../assets/honors/4.jpg"),
  },
  {
    name: "特殊贡献企业科技类",
    pic: require("../../../../assets/honors/5.jpg"),
  },
  {
    name: "国家级火炬计划证书",
    pic: require("../../../../assets/honors/hjjh.png"),
  },
];

const honorList = [
  {
    title: "2023年",
    items: ["$singlee_hn0", "$singlee_hn1"],
  },
  {
    title: "2022年",
    items: ["$singlee_hn2", "$singlee_hn3", "$singlee_hn4"],
  },
  {
    title: "2021年",
    items: ["$singlee_hn5", "$singlee_hn6"],
  },
  {
    title: "2020年",
    items: ["$singlee_hn7", "$singlee_hn8", "$singlee_hn9", "$singlee_hn10"],
  },
  {
    title: "2019年",
    items: ["$singlee_hn11"],
  },
  {
    title: "2018年",
    items: ["$singlee_hn12"],
  },
  {
    title: "2015年",
    items: ["$singlee_hn13"],
  },
  {
    title: "2014年",
    items: ["$singlee_hn14"],
  },
  {
    title: "2013年",
    items: ["$singlee_hn15"],
  },
  {
    title: "2011年",
    items: ["$singlee_hn16"],
  },
  {
    title: "2010年",
    items: ["$singlee_hn17"],
  },
  {
    title: "2009年",
    items: ["$singlee_hn18", "$singlee_hn19"],
  },
  {
    title: "2008年",
    items: ["$singlee_hn20"],
  },
  {
    title: "2007年",
    items: ["$singlee_hn21"],
  },
  {
    title: "2005年",
    items: ["$singlee_hn22", "$singlee_hn23", "$singlee_hn24"],
  },
  {
    title: "2004年",
    items: [
      "$singlee_hn30",
      "$singlee_hn31",
      "$singlee_hn32",
      "$singlee_hn33",
      "$singlee_hn34",
      "$singlee_hn35",
    ],
  },
  {
    title: "2003年",
    items: [
      "$singlee_hn36",
      "$singlee_hn37.",
      "$singlee_hn38",
      "$singlee_hn39",
      "$singlee_hn40",
      "$singlee_hn41",
      "$singlee_hn42",
      "$singlee_hn43",
      "$singlee_hn44",
    ],
  },
  {
    title: "2002年",
    items: ["$singlee_hn45", "$singlee_hn46", "$singlee_hn47"],
  },
  {
    title: "2001年",
    items: [
      "$singlee_hn48",
      "$singlee_hn49",
      "$singlee_hn50",
      "$singlee_hn51",
      "$singlee_hn52",
      "$singlee_hn53",
    ],
  },
  {
    title: "2000年",
    items: ["$singlee_hn54"],
  },
  {
    title: "1999年",
    items: ["$singlee_hn55"],
  },
  {
    title: "1998年",
    items: ["$singlee_hn56"],
  },
  {
    title: "1997年",
    items: ["$singlee_hn57"],
  },
  {
    title: "1996年",
    items: ["$singlee_hn58"],
  },
  {
    title: "1995年",
    items: ["$singlee_hn59"],
  },
];

function Index() {
  const { t } = useTranslation();
  const mobile = useContext(MobileContext);
  const listRef = useRef([]);
  const listRef2 = useRef([]);
  const scrollel = useRef(null);
  const [picTab, setPicTab] = useState(0);
  const [tabIndex, setTabIndex] = useState(2);
  const [swiperRef, setSwiperRef] = useState(null);
  const [tabIndex2, setTabIndex2] = useState(2);
  const [swiperRef2, setSwiperRef2] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);

  const addIndex = () => {
    if (picTab === 0) {
      let temp = tabIndex;
      setTabIndex(
        temp === qualifications.length - 1
          ? qualifications.length - 1
          : temp + 1
      );
    } else {
      let temp = tabIndex2;
      setTabIndex2(temp === honors.length - 1 ? honors.length - 1 : temp + 1);
    }
  };
  const minusIndex = () => {
    if (picTab === 0) {
      let temp = tabIndex;
      setTabIndex(temp === 0 ? 0 : temp - 1);
    } else {
      let temp = tabIndex2;
      setTabIndex2(temp === 0 ? 0 : temp - 1);
    }
  };
  const getRef = (dom) => {
    listRef.current.push(dom);
  };
  const getRef2 = (dom) => {
    listRef2.current.push(dom);
  };

  useEffect(() => {
    if (picTab === 0) {
      swiperRef && swiperRef.slideTo(tabIndex);
      if (!mobile) {
        scrollel.current.scrollLeft =
          listRef.current[tabIndex].offsetLeft - 100;
      } else {
        scrollel.current.scrollLeft = listRef.current[tabIndex].offsetLeft - 10;
      }
    }
  }, [tabIndex]);

  useEffect(() => {
    if (picTab === 1) {
      swiperRef2 && swiperRef2.slideTo(tabIndex2);
      if (!mobile) {
        scrollel.current.scrollLeft =
          listRef2.current[tabIndex2].offsetLeft - 100;
      } else {
        scrollel.current.scrollLeft =
          listRef2.current[tabIndex2].offsetLeft - 10;
      }
    }
  }, [tabIndex2]);

  return (
    <div className={css.container}>
      {previewUrl ? (
        <div
          className={css.preview}
          onClick={() => setPreviewUrl(null)}
          style={{ height: `${window.innerHeight}px` }}
        >
          <img src={previewUrl} alt="" />
        </div>
      ) : null}
      <div className={css.top}>
        <div className={css.title}>{t("$singlee_ab_md4")}</div>
        <div className={css.switch}>
          <div
            className={`${css.switchitem} ${picTab === 0 ? css.select : ""}`}
            onClick={() => {
              setPicTab(0);
            }}
          >
            {t("$singlee_hn60")}
          </div>
          <div
            className={`${css.switchitem} ${picTab === 1 ? css.select : ""}`}
            onClick={() => {
              setPicTab(1);
            }}
          >
            {t("$singlee_hn61")}
          </div>
        </div>
        {picTab === 0 && (
          <div className={`${css.swiperbox} ${picTab === 0 ? css.active : ""}`}>
            <Swiper
              onSwiper={setSwiperRef}
              effect={"coverflow"}
              initialSlide={tabIndex}
              onSlideChange={(swiper) => {
                setTabIndex(swiper.activeIndex);
              }}
              grabCursor={true}
              centeredSlides={true}
              slidesPerView={mobile ? 3 : 5}
              coverflowEffect={{
                rotate: 45,
                stretch: 0,
                depth: 100,
                modifier: 1,
                slideShadows: true,
              }}
              modules={[EffectCoverflow]}
              style={{ padding: "40px 10px" }}
            >
              {qualifications.map((item, index) => {
                return (
                  <SwiperSlide key={index}>
                    <div
                      className={css.swiperitem}
                      style={{ aspectRatio: "2/3" }}
                    >
                      <div
                        className={css.picbox}
                        onClick={() => setPreviewUrl(item.pic)}
                      >
                        <img src={item.pic} alt="" />
                      </div>
                    </div>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
        )}
        {picTab === 1 && (
          <div className={`${css.swiperbox} ${picTab === 1 ? css.active : ""}`}>
            <Swiper
              onSwiper={setSwiperRef2}
              effect={"coverflow"}
              initialSlide={tabIndex2}
              onSlideChange={(swiper) => {
                setTabIndex2(swiper.activeIndex);
              }}
              grabCursor={true}
              centeredSlides={true}
              slidesPerView={mobile ? 3 : 5}
              coverflowEffect={{
                rotate: 45,
                stretch: 0,
                depth: 100,
                modifier: 1,
                slideShadows: true,
              }}
              modules={[EffectCoverflow]}
              style={{ padding: "40px 10px" }}
            >
              {honors.map((item, index) => {
                return (
                  <SwiperSlide key={index}>
                    <div
                      className={css.swiperitem}
                      style={{ aspectRatio: "3/2" }}
                    >
                      <div
                        className={css.picbox}
                        onClick={() => setPreviewUrl(item.pic)}
                      >
                        <img src={item.pic} alt="" />
                      </div>
                    </div>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
        )}
      </div>
      <div className={css.tabzone}>
        <div className={css.larrow} onClick={minusIndex}>
          <div className={css.img}></div>
        </div>
        <div className={css.tabs} ref={scrollel}>
          {picTab === 0 &&
            qualifications.map((item, index) => {
              return (
                <div
                  className={`${css.tab} ${
                    tabIndex === index ? css.select : ""
                  }`}
                  onClick={() => setTabIndex(index)}
                  key={index}
                  ref={getRef}
                >
                  {t(item.name)}
                </div>
              );
            })}
          {picTab === 1 &&
            honors.map((item, index) => {
              return (
                <div
                  className={`${css.tab} ${
                    tabIndex2 === index ? css.select : ""
                  }`}
                  onClick={() => setTabIndex2(index)}
                  key={index}
                  ref={getRef2}
                >
                  {t(item.name)}
                </div>
              );
            })}
        </div>
        <div className={css.rarrow} onClick={addIndex}>
          <div className={css.imgr}></div>
        </div>
      </div>
      <div className={css.contentzone}>
        {honorList.map((item, index) => {
          return <Content item={item} index={index} key={index} />;
        })}
      </div>
    </div>
  );
}

const Content = React.memo(({ item, index }) => {
  const { t } = useTranslation();
  const [ref, refStyle] = useInView(
    () => ({
      from: {
        opacity: 0,
        transform: "translateY(100%)",
      },
      to: {
        opacity: 1,
        transform: "translateY(0%)",
      },
    }),
    { threshold: 0.1, once: true }
  );

  return (
    <div className={css.content} key={index} ref={ref}>
      <div className={css.title}>{t(item.title)}</div>
      <animated.div className={css.desc} style={refStyle}>
        {item.items.map((e, i) => {
          return (
            <div className={css.item} key={i}>
              <div className={css.rect}></div>
              <div className={css.text}>{t(e)}</div>
            </div>
          );
        })}
      </animated.div>
    </div>
  );
});

export default React.memo(Index);
